import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import { DesignationsDto } from './designations.dto';

export class DesignationsResponseModel extends GlobalResponseObject{
    data?: DesignationsDto;
    constructor(status: boolean, intlCode: number, internalMessage: string, data?: DesignationsDto){
        super(status,intlCode,internalMessage);
        this.status = status;
        this.intlCode = intlCode;
        this.internalMessage = internalMessage;
        this.data = data;
    }
}
